module.exports = __webpack_public_path__ + "img/license.4a8801a9.svg";